import { Alert, Avatar, AvatarGroup, Button, CircularProgress, Tooltip } from "@heroui/react";
import Lottie from "react-lottie-player/dist/LottiePlayerLight";
import { coffeeMachine } from "../../../../assets/lottie";
import { useEffect, useState } from "react";
import { useRefreshCurrentGroup } from "../../../../Context/CurrentGroup";
import { GroupMember, Order } from "../../../../api-sdk";
import { AvatarOption } from "../../../../Components/Emojis";

type Props = {
  self: boolean;
  groupMembers: GroupMember[];
  orders: Order[];
  startedBy: string;
  originalSeconds: number;
  seconds: number;
  placedOrder: boolean;
  handlePlaceOrder: () => void;
  handleCloseDrawing: () => void;
};

const ActiveDrawing: React.FC<Props> = (props) => {
  const [remainingTime, setRemainingTime] = useState<number>(props.seconds);
  const refreshCurrentGroup = useRefreshCurrentGroup();

  const fromTime = Math.round(Date.now() / 1000);
  const minutes =
    remainingTime < 0
      ? "00"
      : Math.floor(remainingTime / 60)
          .toString()
          .padStart(2, "0");
  const seconds = remainingTime < 0 ? "00" : (remainingTime % 60).toString().padStart(2, "0");

  useEffect(() => {
    // Countdown
    const interval = setInterval(() => {
      const now = Math.round(Date.now() / 1000);
      const remainingTime = props.seconds - (now - fromTime);
      setRemainingTime(remainingTime);
      if (remainingTime == -5 || (remainingTime < 0 && remainingTime % -15 == 0)) {
        if (refreshCurrentGroup) {
          refreshCurrentGroup();
        }
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  // Sort members by who has ordered
  props.groupMembers.sort((a, b) => {
    const aHasOrdered = props.orders.find((order) => order.user.id == a.user.id) != undefined;
    const bHasOrdered = props.orders.find((order) => order.user.id == b.user.id) != undefined;
    if (aHasOrdered && !bHasOrdered) return -1;
    if (!aHasOrdered && bHasOrdered) return 1;
    return 0;
  });

  return (
    <>
      <div className="flex flex-col items-center">
        <CircularProgress
          color="primary"
          formatOptions={{ style: "percent" }}
          label={`${minutes}:${seconds}`}
          showValueLabel={false}
          size="lg"
          value={(remainingTime / props.originalSeconds) * 100}
          classNames={{ label: "text-xl" }}
        />
      </div>
      <Lottie loop animationData={coffeeMachine} play speed={0.1} segments={[34, 120]} style={{ maxHeight: 500, height: "60%" }} />
      <div className="flex justify-center">
        <AvatarGroup>
          {props.groupMembers.map((member) => {
            const hasOrdered = props.orders.find((order) => order.user.id == member.user.id) != undefined;
            return (
              <Tooltip content={member.user.name} key={member.user.id}>
                <Avatar src={new AvatarOption(member.user.avatar).getUrl()} isDisabled={!hasOrdered} />
              </Tooltip>
            );
          })}
        </AvatarGroup>
      </div>
      {props.self && (
        <div className="mb-4">
          <Alert color="success" title={props.startedBy + " haalt koffie voor jullie!"} />
        </div>
      )}
      {!props.self && (
        <div className="mb-4">
          <Alert color="primary" title={"Er vindt een loting plaats"} />
        </div>
      )}
      {remainingTime > 0 && (
        <div className="flex flex-col gap-2">
          <Button fullWidth color="primary" isDisabled={props.placedOrder} variant="solid" onPress={props.handlePlaceOrder}>
            Bestelling doorgeven
          </Button>
          <Button fullWidth color="primary" isDisabled={remainingTime < 5} variant="bordered" onPress={props.handleCloseDrawing}>
            Ronde nu sluiten
          </Button>
        </div>
      )}
      {remainingTime <= 0 && (
        <Button fullWidth color="danger" variant="bordered" onPress={() => refreshCurrentGroup && refreshCurrentGroup()}>
          Uitslag niet zichtbaar? Klik hier om te refreshen
        </Button>
      )}
    </>
  );
};

export default ActiveDrawing;
